const getFeatureInfo = (featuresData,header,feature) => {
  for (let featureData of featuresData) {
    if (header === featureData.label) {
      if (featureData.items[feature]) {
        return featureData.items[feature];
      }
    }
  }
  return null;
}


export const gcFrontPageContentData = () => {

  const featuresData = getFeaturesData();
  return {
    "PlanYourProduction":{
      "pageTitle":"PLAN YOUR PRODUCTION",
      "items":[
        {...getFeatureInfo(featuresData,'PLANNING AND FORECASTING',0)},
        {...getFeatureInfo(featuresData,'PLANNING AND FORECASTING',1)},
        {...getFeatureInfo(featuresData,'PLANNING AND FORECASTING',2)},
      ],
      "links":[{
        to: '/how-it-works',
        label: 'How it works'
      }]
    },
    "MonitorYourProduction":{
      "pageTitle":"MONITOR YOUR PRODUCTION",
      "items":[
        {...getFeatureInfo(featuresData,'OPERATIONAL VISIBILITY',0)},
        {...getFeatureInfo(featuresData,'OPERATIONAL VISIBILITY',1)},
        {...getFeatureInfo(featuresData,'OPERATIONAL VISIBILITY',2)},
      ],
      "links":[{
        to: '/how-it-works',
        label: 'How it works'
      }]
    }
  }
}

export const gcApiPageContentData = {
  "Api":{
    "pageTitle":"API",
    "pageTitleSubStr":"",
    "subHeader":"",
    "imgSrc":"/placeholder-min.png",
    "imgAlt":"hero image alt"
  },
};
export const gcEdgePageContentData = {
  "Edge":{
    "pageTitle":"EDGE",
    "pageTitleSubStr":"",
    "subHeader":"",
    "imgSrc":"/placeholder-min.png",
    "imgAlt":"hero image alt"
  },
};

export const getCaseStudiesData = () => {
  return [{
    label:"PROFESSIONAL",
    items:[
      {label:"ORGANIC PRODUCE",slug:'case-study-organic-produce'},
      {label:"FLOWER GARDEN",slug:'case-study-flower-garden'}],

  },{
    label:"RESEARCH AND INDUSTRY",
    items:[
      {label:"SURVEILLANCE",slug:'case-study-surveillance'},
      {label:"BREEDING PROGRAM",slug:'case-study-breeding-program'}]
  },{
    label:"CERTIFICATION",
    items:[
      {label:"CERTIFIED ORGANIC",slug:'case-study-certified-organic'},
      {label:"FSSC AND ISO",slug:'case-study-fssc-and-iso'}]
  }];
}

export const getFeaturesData = () => {
  return [{
    label:"INFRASTRUCTURE AND APPLICATION ARCHITECTURE",
    links: [
      {to:'/how-it-works', label:'HOW IT WORKS'},
    ],
    items:[
      {label:"Stateless, event-driven, asynchronous and near-realtime system design"},
      {label:"Multi, whitelisted and single tenant support"}]
  },{
    label:"SECURITY AND IDENTITY",
    links: [
      {to:'/policy/ace-policy-security', label:'SECURITY POLICY'},
    ],
    items:[
      {label:"Passwordless Authentication (MFA, Gmail, Microsoft, Apple)"},
      {label:"Multi-tenant isolation (Individual data partitions/layers)"}]
  },{
    label:"SCALE AND DEPLOYMENT",
    links: [],
    items:[
      {label:"Apex scale-unit density"},
      {label:"Planetary-scale delivery strategies"},
      {label:"On-prem/Cloud hybrid flexibility"}]
  },{
    label:"PLANNING AND FORECASTING",
    links: [
      {to:'/resource/ace-guide-forecasting', label:'AUTO: Forecasting'},
      {to:'/resource/ace-guide-successions-and-lots', label:'AUTO: Successions and Lots'},
    ],
    items:[
      {label:"Multi-site Production Planning Tools"},
      {label:"Dynamic Production Calendars"},
      {label:"Production and Consumption forecast tools"},
      {label:"KPI forecasting"}]
  },{
    label:"OPERATIONAL VISIBILITY",
    links: [
      {to:'/resource/ace-guide-reporting', label:'AUTO: Reporting'},
      {to:'/resource/vendors-guide-reporting', label:'VENDORS: Reporting'},
    ],
    items:[
      {label:"Live KPI indicators"},
      {label:"Traceability and Compliance"},
      {label:"Comprehensive Reporting"}]
  },{
    label:"CONNECTIVITY",
    links: [],
    items:[
      {label:"IOT Integration"},
      {label:"On-prem Edge Services"}]
  },{
    label:"INTEGRATION AND EDGE",
    links: [],
    items:[
      {label:"Site-specific agents (Germination, Propagation, Cultivation)"},
      {label:"Real-time data-point collection for sensor readings"}]
  },{
    label:"AI INTEROPERABILITY",
    links: [
      {to:'/policy/ace-policy-ai', label:'AI POLICY'},
    ],
    items:[
      {label:"AI Agent friendly APIs "},
      {label:"Structured metadata and semantics"}]
  },{
    label:"APIs AND SYSTEM DESIGN",
    links: [
      {to:'/api', label:'API'},
      {to:'/resource/ace-guide-adoption', label:'Adoption'},
    ],
    items:[
      {label:"Open and platform-agnostic APIs"},
      {label:"Decouple your technology selections from unified production planning"},
      {label:"Formal and straightforward specifications for system integration"}]
    // },{
    //   label:"Market & Supply",
    //   items:[
    //     {label:"GC Market:  Transactional fees and in-app ordering"},
    //     {label:"GC Vendors: Supply network quality management and surveillance"}]
    // },{
  },{
    label:"COMPLIANCE AND CERTIFICATION SUPPORT",
    links: [
      {to:'/case-study/case-study-certified-organic', label:'CASE STUDY: Certified Organic'},
      {to:'/case-study/case-study-fssc-and-iso', label:'CASE STUDY: FSSC and ISO'},
    ],
    items:[
      {label:"Data collection for certifications (Organic, FoodSafety, Pharmaceutical)"}
    ],
  },{
    label:"DOCUMENTATION AND RESOURCES",
    links: [
      {to:'/resources', label:'RESOURCES'},
    ],
    items:[
      {label:"Formal specifications and usage resources"}
    ]
  },{
    label:"STARTER KITS",
    links: [],
    items:[
      {label:"Pre-configured hardware/software bundles for quick adoption"}
    ]
  }
  ]
}

export const getResourcesData = () => {

  return [{
    label:"GETTING STARTED",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-getting-started'
  },{
    label:"ADOPTION",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-adoption'
  },{
    label:"SITES AND CONFIGURATIONS",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-sites-and-configurations'
  },{
    label:"DISPENSARY",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-dispensary'
  },{
    label:"SUCCESSIONS AND LOTS",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-successions-and-lots'
  },{
    label:"FORECASTING",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-forecasting'
  },{
    label:"REPORTING",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-reporting'
  },{
    label:"VENDORS",
    type:'GUIDE',
    product:'AUTO',
    slug:'ace-guide-vendors'
  },{
    label:"PROGRAMS",
    type:'GUIDE',
    product:'VENDORS',
    slug:'vendors-guide-programs'
  },{
    label:"PLACEMENTS",
    type:'GUIDE',
    product:'VENDORS',
    slug:'vendors-guide-placements'
  },{
    label:"FORECASTING",
    type:'GUIDE',
    product:'VENDORS',
    slug:'vendors-guide-forecasting'
  },{
    label:"REPORTING",
    type:'GUIDE',
    product:'VENDORS',
    slug:'vendors-guide-reporting'
  }];
}